import { render, staticRenderFns } from "./HeroSection2.vue?vue&type=template&id=674bcde7&"
import script from "./HeroSection2.vue?vue&type=script&lang=js&"
export * from "./HeroSection2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports